<template>
  <form @submit.prevent="handleSubmit" id="team_create_form">
    <!-- Team Name -->
    <div class="mb-4">
      <label class="form-label form-label-thin">Team Name <span class="text-danger">*</span></label>
      <input type="text" class="form-control form-control-thin" id="name" name="name" ref="name" v-model="form.name"
        placeholder="Team Name" />
    </div>

    <!-- Head Selection with Add User Button -->
    <div class="mb-4">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <label class="form-label form-label-thin mb-0">
          Head <span class="text-danger">*</span>
        </label>

        <button type="button" class="btn btn-sm btn-link text-primary text-decoration-none p-0"
          @click="openCreateUserModal">
          <i class="fa fa-plus-circle me-1"></i>
          Add User
        </button>
        </div>
      <div class="d-flex gap-2">
        <MultiSelect v-model="form.head" :options="members" value-key="external_id" label-key="name"
          placeholder="Select Head" :multiple="false" class="flex-grow-1" name="head" id="head" ref="head" />
      
      </div>
    </div>
    
    <!-- Members Selection with Add User Button -->
    <div class="mb-4">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <label class="form-label form-label-thin mb-0">
          Members <span class="text-danger">*</span>
        </label>

        <button type="button" class="btn btn-sm btn-link text-primary text-decoration-none p-0"
          @click="openCreateUserModal">
          <i class="fa fa-plus-circle me-1"></i>
          Add User
        </button>
      </div>
      <div class="d-flex gap-2">
        <MultiSelect v-model="form.members" :options="members" option-value="external_id" option-label="name"
          placeholder="Select Members" multiple class="flex-grow-1" name="members" id="members" ref="members" />
       
      </div>
      <small class="text-muted">Hold Ctrl/Cmd to select multiple members</small>
    </div>

    <!-- Description -->
    <div class="mb-4">
      <label class="form-label form-label-thin">Description If Any</label>
      <textarea class="form-control form-control-thin" id="description" name="description" ref="description"
        v-model="form.description" placeholder="Team Description" rows="2"></textarea>
    </div>

    <!-- Modal Footer -->
    <div class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-sm btn-outline-secondary hover-white" @click="close">
        <i class="fa fa-times"></i> Cancel
      </button>
      <button type="submit" class="btn btn-primary py-1 px-2 text-light hover-white btn-sm form-submit-btn">
        <i class="fa-solid fa-plus fs-12"></i> Create
      </button>
    </div>
  </form>
  <FormModal ref="createUserModal" title="Create New User" id="create_user_form_modal">
    <CreateUser @created="onUserCreated" @close="closeCreateUserModal" />
  </FormModal>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'
import FormModal from '@/components/utils/FormModal.vue'
import CreateUser from '@/views/User/CreateUser.vue'
import MultiSelect from '@/components/MultiSelect.vue'

export default {
  name: 'CreateTeam',
  components: {
    FormModal,
    CreateUser,
    MultiSelect
  },
  emits: ['created', 'close'],
  data() {
    return {
      form: {
        name: '',
        description: '',
        head: '',
        members: []
      },
      submitting: false,
      members: []
    }
  },
  mounted() {
    this.get_members()
  },
  methods: {
    async handleSubmit() {
      this.submitting = true

      try {
        const fd = new FormData()

        fd.append('name', this.form.name)
        fd.append('description', this.form.description)

        if (this.form.head) {
          fd.append('head', this.form.head)
        }

        this.form.members.forEach(id => {
          fd.append('members[]', id)
        })

        const result = await form_api_submit({
          url: 'team/create',
          method: 'POST',
          data: fd,
          curr_form_id: '#team_create_form'
        })

        if (result.success) {
          this.$emit('created')
          this.close()
          this.resetForm()
        }

      } finally {
        this.submitting = false
      }
    },
    async get_members() {
      this.submitting = true

      const result = await form_api_submit({
        url: 'user/dropdown',
        method: 'GET',
        data: this.form,
        show_success_toast: false
      })

      if (result.success) {
        this.members = (result.data || []).map(member => ({
          id: member.id,
          name: `${member.first_name} ${member.last_name}`,
          external_id: member.external_id,
        }))
      }
      this.submitting = false
    },

    openCreateUserModal() {
      this.$refs.createUserModal.showModal()
    },

    closeCreateUserModal() {
      this.$refs.createUserModal.closeModal()
    },

    async onUserCreated() {
      // Refresh the members dropdown when a new user is created
      await this.get_members()
      this.closeCreateUserModal()
    },

    close() {
      this.$emit('close')
    },

    resetForm() {
      this.form = {
        name: '',
        description: '',
        head: '',
        members: []
      }
    }
  }
}
</script>